// extracted by mini-css-extract-plugin
export var brand = "Brand-module--brand--2-g8K";
export var brand__logo = "Brand-module--brand__logo--19EcB";
export var brand__title = "Brand-module--brand__title--2USPO";
export var dark = "Brand-module--dark--e5-2F";
export var light = "Brand-module--light--2jaiz";